export default {
  user: {
    current: null,
    showEmailConfirmation: false
  },
  common: {
    asyncAction: null,
    confirmAction: null
  },
  plan: {
    selected: null
  }
};
